export default function() {
  // Set max-height on menu hover to trigger animation and open menu
  $(document).on('mouseenter', '[data-nav-menu-hover]', (e) => {
    const $menu = $(e.currentTarget).find('[data-nav-menu]');
    const max_height = $menu.find('[data-nav-container]').outerHeight();
    $menu.css('max-height', max_height);
    $(e.currentTarget).addClass('NavList__heading--active');
  });

  // Unset max-height to close menu
  $(document).on('mouseleave', '[data-nav-menu-hover]', (e) => {
    const $menu = $(e.currentTarget).find('[data-nav-menu]');
    $menu.css('max-height', 0);
    $(e.currentTarget).removeClass('NavList__heading--active');
  });
}